import AgoExample from "./examples/Ago.Example";
import DurationExample from "./examples/Duration.Example";

export default [
    {
        title: "Ago",
        component: AgoExample,
        code: require("!raw-loader!./examples/Ago.Example.tsx")
    },
    {
        title: "Duration",
        component: DurationExample,
        code: require("!raw-loader!./examples/Duration.Example.tsx")
    }
];
